import { httpClient } from "@/services";

export default {
	state: {
		accountGeoListLimit: null,
		accountGeoListOrder: null,
		accountGeoListRows: null,
		accountGeoListSort: null,
		accountGeoListTotal: null,
		accountGeoListTotals: null,
		accountGeoFilters: null,
	},
	mutations: {

		updateAccountGeoList(state, payload) {
			const { limit, order, rows, sort, total } = payload;
			state.accountGeoListLimit = limit;
			state.accountGeoListOrder = order;
			state.accountGeoListRows = rows;
			state.accountGeoListSort = sort;
			state.accountGeoListTotal = total;
			state.accountGeoListTotals = { id: total };
		},
		updateAccountGeoFilters(state, payload) {
			state.accountGeoFilters = payload;
		},
	},
	actions: {

		async getAccountGeoList({ dispatch, commit }, values) {
			try {
				// dispatch('actionPreloader', true);
				const { data } = await httpClient.post('/info/geo/list', values);
				if (data && data.status) {
					commit('updateAccountGeoList', data);
				} else {
					// commit('updateUser', { user: null, managers: null });
					dispatch('setAlert', { type: "error", message: "Server Error" });
				}
				// dispatch('actionPreloader', false);
			} catch (e) {
				console.error(e);
			}
		},
		async getAccountGeoListFilter({ dispatch, commit }, values) {
			try {
				// dispatch('actionPreloader', true);
				const { data } = await httpClient.post('info/geo/filters', values);
				if (data && data.filter) {
					commit('updateAccountGeoFilters', data.filter);
				} else {
					// commit('updateUser', { user: null, managers: null });
					dispatch('setAlert', { type: "error", message: "Server Error" });
				}
				// dispatch('actionPreloader', false);
			} catch (e) {
				console.error(e);
			}
		},

	},
	getters: {
		accountGeoListLimit: s => s.accountGeoListLimit,
		accountGeoListOrder: s => s.accountGeoListOrder,
		accountGeoListRows: s => s.accountGeoListRows,
		accountGeoListSort: s => s.accountGeoListSort,
		accountGeoListTotal: s => s.accountGeoListTotal,
		accountGeoListTotals: s => s.accountGeoListTotals,

		accountGeoFilters: s => s.accountGeoFilters,
	}
};
